import { coreSystem } from "../core/index.js";
import { MdastHeadingVisitor } from "./MdastHeadingVisitor.js";
import { HeadingNode } from "@lexical/rich-text";
import { LexicalHeadingVisitor } from "./LexicalHeadingVisitor.js";
import { system } from "../../gurx/realmFactory.js";
import { realmPlugin } from "../../gurx/react.js";
const headingsSystem = system((_) => ({}), [coreSystem]);
const [headingsPlugin] = realmPlugin({
  id: "headings",
  systemSpec: headingsSystem,
  init: (realm) => {
    realm.pubKey("addImportVisitor", MdastHeadingVisitor);
    realm.pubKey("addLexicalNode", HeadingNode);
    realm.pubKey("addExportVisitor", LexicalHeadingVisitor);
  }
});
export {
  headingsPlugin,
  headingsSystem
};
